import React, { FormEvent, InputHTMLAttributes } from 'react';
import { MdOutlineSearch, MdOutlineClose } from 'react-icons/md';

import styles from './styles.module.css';
import { Button } from '../Button';

export interface InputSearchProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'name' | 'onSubmit'> {
  buttonLabel?: string;
  onSubmit: (search: string) => void;
  onClear?: () => void;
}

export const InputSearch: React.FC<InputSearchProps> = ({
  id = 'search',
  type = 'text',
  buttonLabel = 'Buscar',
  onSubmit,
  onClear,
  value,
  ...props
}) => {
  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const search = formData.get('search')!.toString();

    onSubmit(search);
  }

  function handleOnClear() {
    if (!onClear) return;

    onClear();
    onSubmit('');
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className={styles.inputSearchContainer}>
        <MdOutlineSearch className={styles.inputSearchIcon} size={24} />
        <label htmlFor={id} className={styles.srOnly}>
          {buttonLabel} por palavra-chave
        </label>
        <input
          id={id}
          className={styles.inputSearch}
          name="search"
          type={type}
          value={value || ''}
          {...props}
        />

        {value && onClear && (
          <MdOutlineClose
            className={styles.inputSearchClear}
            size={24}
            onClick={handleOnClear}
            cursor={'pointer'}
          />
        )}

        <Button
          type="submit"
          variant="default"
          size="small"
          label={buttonLabel}
        />
      </div>
    </form>
  );
};
